import React from 'react';

interface InputFieldProps {
    label?: string;
    value: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    maxLength?: number;
    required?: boolean;
    helperText?: string;
    name?: string;
    type?: string;
    className?: string;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    error?: boolean;
    disabled?: boolean;
    labelClassName?: string;
    showRequiredIndicator?: boolean; // New Prop
    errorMessage?: string;
}

const InputField: React.FC<InputFieldProps> = ({
    label,
    value,
    onChange,
    placeholder,
    maxLength,
    required = false,
    disabled,
    name,
    helperText,
    type = 'text',
    showRequiredIndicator = true, // Default to true for backward compatibility
}) => {
    return (
        <div className="">
            <label className="block text-black text-sm mb-2">
                {label} {required && showRequiredIndicator && '*'}
            </label>
            <input
                type={type}
                name={name}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                className="w-96 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            />
            {helperText && (
                <p className="text-gray-500 text-xs mt-1">{helperText}</p>
            )}
        </div>
    );
};

export default InputField;
